import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'src/app/core/config/configuration.service';
import { Gender, PurgeIntervals } from '..';

@Injectable()
export class PracticeInvitationProxy {
    constructor(private http: HttpClient, private configurationService: ConfigurationService) {}

    async create(createPracticeInvitationDTO: CreatePracticeInvitationDTO): Promise<void> {
        const url = this.configurationService.APIURL + '/api/invitations';
        await this.http.post(url, createPracticeInvitationDTO).toPromise();
    }

    async delete(id: string): Promise<void> {
        const url = this.configurationService.APIURL + '/api/invitations/' + id;
        await this.http.delete(url).toPromise();
    }

    async get(): Promise<InvitationSummaryDTO[]> {
        const url = this.configurationService.APIURL + '/api/invitations';
        return await this.http.get<InvitationSummaryDTO[]>(url).toPromise();
    }

    async getValidation(code: string): Promise<InvitationDetailsDTO> {
        const url = this.configurationService.APIURL + '/api/invitations/' + code;
        return await this.http.get<InvitationDetailsDTO>(url).toPromise();
    }

    async acceptInvitation(code: string, acceptInvitationDTO: AcceptInvitationDTO): Promise<void> {
        const url = this.configurationService.APIURL + '/api/invitations/' + code + '/accept';
        await this.http.post(url, acceptInvitationDTO).toPromise();
    }

    async resendInvitation(code: string): Promise<void> {
        const url = this.configurationService.APIURL + '/api/invitations/' + code + '/resend';
        await this.http.post(url, {}).toPromise();
    }
}

export interface CreatePracticeInvitationDTO {
    practiceName: string;
    debtorNumber: string;
    countryCode: string;
    language: string;
    isChairOrdersEnabled: boolean;
    invoiceParentPracticeId: string;
    mainContact: MainContactDTO;
}

export interface InvitationSummaryDTO {
    id: string;
    name: string;
    debtorNumber: string;
    countryCode: string;
    invoiceParentPracticeName: string;
    expirationDate: Date | string;
    email: string;
    emailBounced: boolean;
    emailOpened: boolean;
    invitationURL: string;
}

export interface MainContactDTO {
    firstName: string;
    lastName: string;
    gender: Gender;
    emailAddress: string;
}

export interface InvitationDetailsDTO {
    isValid: boolean;
    isAccepted: boolean;
    isExpired: boolean;
    isChairOrdersEnabled: boolean;
    practiceName: string;
    countryCode: string;
    language: string;
    invoiceParentPracticeName: string;
    firstName: string;
    lastName: string;
    gender: Gender;
    email: string;
}

export interface AcceptInvitationDTO {
    code: string;
    name: string;

    street: string;
    number: string;
    postalCode: string;
    city: string;
    countryCode: string;

    phoneNumber: string;
    language: string;
    purgeInterval: PurgeIntervals;
    focusArea: string;

    mainContact: InvitationMainContactDTO;
    team: ContactDTO[];
}

export interface ContactDTO {
    firstName: string;
    lastName: string;
    gender: Gender;
    emailAddress: string;
    isPracticeManager: boolean;
    isInvoiceReceiver: boolean;
}

export interface InvitationMainContactDTO {
    firstName: string;
    lastName: string;
    password: string;
    isInvoiceReceiver: boolean;
}
